<template>
  <div class="group-tiles">
    <div
      v-for="group in gmfGroups"
      :key="group.id"
      v-ripple
      class="group-tiles_group"
      @click="
        () => {
          setGmf(group)
          $emit('group:update', group)
        }
      "
    >
      <span :class="{ 'opacity_6 ': group.soon }">
        {{ $t(`gametypes.groups.${group.id}`) }}
      </span>
    </div>
  </div>
</template>

<script>
import { getPreferredGmf } from '@/store/gameformat/gameformat'

export default {
  name: 'GmfGroupsSelektor',
  props: {
    namespace: { String, required: true },
    hasGroupActive: Boolean,
  },
  emits: ['group:update'],
  data() {
    return {
      open: false,
      gmix_hasDepthList: false,
    }
  },
  methods: {
    async setGmf(group) {
      const result = await this.$store.dispatch('get_gameformat_groups', [group.mode])
      if (!result || result.error) return

      const gameformat = getPreferredGmf({ gameformats: this.$store.getters.gameformats })
      const storeAction = `${this.namespace ? `${this.namespace}/` : ''}router_update_query`
      this.$store.dispatch(storeAction, {
        query: {
          stacks: gameformat.stacks,
          gametype: gameformat.gametype,
          depth: gameformat.depth,
        },
        push: false,
        replace: true,
        saveLocally: false,
      })
      this.$store.dispatch('tra/alpha/router_initialize', { localOnly: false })
    },
  },
  computed: {
    gmfGroups() {
      return [
        { id: 'cash', mode: 'Cash' }, //
        { id: 'mtt', mode: 'MTT' },
        { id: 'spins', mode: 'Spins' },
        { id: 'husng', mode: 'HuSng' },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.group-tiles {
  gap: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  // width: 100%;
  &_group {
    font-size: 1.5rem;
    border-radius: 8px;
    border: solid 2px var(--clr-black-3);
    background: var(--clr-black-1);
    min-height: 8rem;
    min-width: 18rem;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 0.5rem;
    transition: 0.22s;
    font-weight: 500;
    cursor: pointer;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 1.3px;
    padding: 1.5rem;
    &_active {
      color: var(--clr-primary);
      border: solid 1px var(--clr-primary);
      background: var(--clr-primary);
      color: white;
    }
    &:hover {
      background: var(--clr-primary-3);
      color: var(--clr-primary);
      border: solid 2px var(--clr-primary-1);
    }
  }
}

@media (max-width: 1024px) {
  .group-tiles {
    &_group {
      min-width: 0;
    }
  }
}
</style>
